/**
 * @generated SignedSource<<20260aa6b8478931acaa6825f58a5693>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateUserProfilePassword = {
  oldPassword: string;
  newPassword: string;
};
export type authUpdateUserProfilePasswordMutation$variables = {
  id: string;
  input: UpdateUserProfilePassword;
};
export type authUpdateUserProfilePasswordMutation$data = {
  readonly updateUserProfilePassword: boolean;
};
export type authUpdateUserProfilePasswordMutation = {
  variables: authUpdateUserProfilePasswordMutation$variables;
  response: authUpdateUserProfilePasswordMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "updateUserProfilePassword",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "authUpdateUserProfilePasswordMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "authUpdateUserProfilePasswordMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "07943043bb83f3500b6b5f23633f7230",
    "id": null,
    "metadata": {},
    "name": "authUpdateUserProfilePasswordMutation",
    "operationKind": "mutation",
    "text": "mutation authUpdateUserProfilePasswordMutation(\n  $id: ID!\n  $input: UpdateUserProfilePassword!\n) {\n  updateUserProfilePassword(id: $id, input: $input)\n}\n"
  }
};
})();

(node as any).hash = "40d5c2ab9a8b9d38f88c75b70e62c904";

export default node;
